/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule, Routes} from '@angular/router';
import {translations} from '../../environments/translations.ru';
import {LayoutComponent} from './shared/layout/layout.component';
import {NotFoundComponent} from './shared/not-found/not-found.component';

/**
 * Routes available in cabinet module
 *
 * @usageNotes
 * path: 'cabinet/dashboard' - lazy loading of dashboard module, activating is possible
 * only with guard service
 * {@link https://angular.io/guide/router}
 * {@link https://angular.io/guide/lazy-loading-ngmodules}
 */
console.log('showcase')
export const showCaseRoutes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    data: {showcase: true},
    children: [
      {
        path: '',
        redirectTo: 'catalog',
        pathMatch: 'full',
        data: {
          breadcrumb: {label: translations.bc.home},
        },
      },
      {
        path: 'catalog',
        data: {breadcrumb: {skip: true}, showcase: true},
        loadChildren: () => import('./catalog/catalog.module').then(m => m.CatalogModule)
      },
      {
        path: 'product',
        data: {showcase: true},
        loadChildren: () => import('./product/product.module').then(m => m.ProductModule)
      },      
      {path: '404', component: NotFoundComponent},
      {path: '**', redirectTo: '/404'}
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(showCaseRoutes), BrowserAnimationsModule],
  exports: [RouterModule]
})
export class CabinetRoutingModule {
}
